import React from "react";
import { Modal } from "react-bootstrap";
import VolumeFoliosList from "containers/property/VolumeFoliosList";

function VolumeFoliosModal({
  show,
  toggleVolumeFoliosModal,
  isAuthenticated,
  filter,
  data,
  dataFetch,
  updateTableState,
  saveRecord,
  deleteRecord,
  validateRelatedRecord,
  user,
  stateCode,
}) {
  if (!isAuthenticated) {
    return null;
  }

  return (
    <Modal
      show={show}
      onHide={toggleVolumeFoliosModal}
      dialogClassName="property-table-modal-wide"
    >
      <Modal.Header closeButton>
        <Modal.Title>Volume Folio Details</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ overflowX: "scroll" }}>
        <VolumeFoliosList
          filter={filter}
          isAuthenticated={isAuthenticated}
          controlType="table"
          user={user}
          data={data}
          dataFetch={dataFetch}
          updateTableState={updateTableState}
          saveRecord={saveRecord}
          deleteRecord={deleteRecord}
          validateRelatedRecord={validateRelatedRecord}
          stateCode={stateCode}
        />
      </Modal.Body>
    </Modal>
  );
}

export default VolumeFoliosModal;

